import { DefaultTheme } from "styled-components";
import { isIE } from "react-device-detect";

const COLORS = {
  primary: "#003C68",
  secondary: "#93328E",
  tertiary: "#005eb8",
  focus: "#f9b000",
  focusLight: "#e5eef7",
  white: "#FFFFFF",
  black: "#000000",
  disabled: "#f1f1f1",
  success: "#329b83",
  danger: "#AA112C",
};

const varmlandTheme: DefaultTheme = {
  fontFamily: "Open Sans",
  colors: COLORS,
  button: {
    radius: "30px",
    primary: {
      color: COLORS.primary,
      hover: "#003053",
    },
    secondary: {
      color: COLORS.white,
      hover: COLORS.focusLight,
    },
    copy: {
      backgroundColor: COLORS.white,
      borderColor: COLORS.primary,
      hover: {
        backgroundColor: COLORS.focusLight,
      },
    },
    success: {
      color: COLORS.success,
      hover: "#008264",
      textColor: COLORS.white,
    },
    danger: {
      color: COLORS.danger,
      hover: "#880e23",
    },
  },
  horizontalLine: {
    color: COLORS.primary,
  },
  icon: {
    fill: COLORS.primary,
  },
  input: {
    backgroundColor: COLORS.focusLight,
    color: COLORS.primary,
    dangerColor: "#ff8fa0",
    disabledColor: COLORS.disabled,
    disabledColorSupplement: "#e4e4e4",
    toggle: {
      inActiveColor: "#fefefe",
      inActiveBackgroundColor: "#dadada",
    },
    border: {
      width: "1px",
      radius: "0rem",
      color: "#99b1c2",
    },
    focus: {
      backgroundColor: COLORS.focusLight,
      color: COLORS.black,
      border: {
        color: COLORS.primary,
      },
    },
    dropDown: {
      backgroundColor: COLORS.focusLight,
      listBackgroundColor: COLORS.white,
      color: COLORS.primary,
      marginTop: isIE ? "6px" : "43px",
      border: {
        width: "1px",
        color: COLORS.primary,
      },
      hover: {
        color: COLORS.primary,
        backgroundColor: COLORS.focusLight,
        border: COLORS.primary,
      },
    },
  },
  navbar: {
    color: COLORS.white,
    backgroundColor: COLORS.primary,
    border: {
      color: COLORS.primary,
      width: "3px",
    },
    logo: {
      height: "45px",
      marginTop: "-15px",
      marginBottom: "-10px",
    },
    link: {
      hover: {
        color: COLORS.primary,
        backgroundColor: COLORS.focusLight,
      },
    },
  },
  table: {
    row: {
      odd: {
        backgroundColor: COLORS.focusLight,
        color: COLORS.black,
      },
      even: {
        backgroundColor: COLORS.white,
        color: COLORS.black,
      },
      hover: {
        backgroundColor: COLORS.focus,
        color: COLORS.black,
      },
    },
  },
  typography: {
    headerPrimaryColor: COLORS.primary,
    paragraphPrimaryColor: COLORS.black,
    fontSize: "14px",
    font: "Open Sans",
    boldFont: "Open Sans",
    headingFont: "Helvetica Neue",
    headingFontWeight: "normal",
    linkColor: COLORS.primary,
  },
  checkbox: {
    border: {
      color: COLORS.primary,
    },
    check: {
      border: {
        color: COLORS.white,
      },
    },
    hover: {
      border: {
        color: COLORS.primary,
      },
    },
  },
  radioButton: {
    border: {
      color: COLORS.primary,
    },
    check: {
      border: {
        color: COLORS.white,
      },
    },
    hover: {
      border: {
        color: COLORS.primary,
      },
    },
  },
  spinner: {
    color: COLORS.primary,
  },
  feedback: {
    color: COLORS.white,
  },
};

export default varmlandTheme;
